export default {
  settingZones: {
    header: {
      province: '省',
      city: '市',
      district: '区',
    },

    table: {
      province: '省',
      city: '市',
      district: '区',
      logistics: '指定物流',
      logisticsBusiness: '指定物流业务',
      updater: '更新人',
      lastUpdated: '最近更新时间',
    },

    dialog: {
      editTitle: '编辑省市区配置',
      addTitle: '新建省市区配置',
      province: '省',
      city: '市',
      district: '区',
      logistics: '指定物流',
      selectLogistics: '请选择指定物流',
      business: '指定业务',
      selectBusiness: '请选择指定业务',
      selectLogisticsValid: '请先选择所属物流商',
      selectProvince: '请选择省份',
      urbanArea: '请选择市区',
      area: '请选择地区',
    }
  }
};
